<template>
  <b-form-select id="state" :value="currentState" :options="states" v-on:change="change" autocomplete="address-level1" required/>
</template>
<script>
export default {
  name: 'FormOptionState',
  props: ['country', 'state', 'city'],
  data: function () {
    return {
      currentState: null,
      states: []
    }
  },

  mounted: function () {
    this.loadStates()
    this.currentState = this.state ? this.state : null
  },

  watch: {
    state: function (state) {
      this.currentState = state
    },
    city: function () {
      this.findByCity()
    }
  },

  methods: {
    findByCity: function () {
      this.states.forEach(state => {
        if (state.text === this.city) {
          this.change(state.value)
        }
      })
    },

    change: function (value) {
      if (value !== this.currentState) {
        this.currentState = value
        this.$emit('selected', value)
      }
    },

    loadStates: function () {
      this.axios.get('/states/' + this.country.toLowerCase())
        .then(rsp => {
          rsp.data.forEach(state => {
            this.states.push({ value: state.code, text: state.name })
          })
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/misc/FormOptionState.vue